import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    // LearnerPage Access Level Roles
    { value: 'learnerpages:restricted', label: 'Restricted' },
    { value: 'learnerpages:standard', label: 'Standard' },
    { value: 'learnerpages:sensitive', label: 'Sensitive' },
    { value: 'learnerpages:confidential', label: 'Confidential' },
    { value: 'learnerpages:accesscontrollevel', label: 'Access Control Level' },
  ],
});
